import { render, staticRenderFns } from "./ShipmentFilters.vue?vue&type=template&id=518626d0&"
import script from "./ShipmentFilters.vue?vue&type=script&lang=js&"
export * from "./ShipmentFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports